/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */

import { registerPlugin } from '@capacitor/core';

import type { DocutainSDKPlugin } from './definitions';

/**
 * DocutainSDK instance.
 */
const DocutainSDK = registerPlugin<DocutainSDKPlugin>('DocutainSDK', {
  web: () => import('./web').then(m => new m.DocutainSDKWeb()),
});

export * from './definitions';
export { DocutainSDK };
